import SpecialProjectItemExpert from '../ui/SpecialProjectItemExpert.vue';
import SpecialProjectItemImageBackground from '../ui/SpecialProjectItemImageBackground.vue';
import SpecialProjectItemImageBig from '../ui/SpecialProjectItemImageBig.vue';
import SpecialProjectItemWide from '../ui/SpecialProjectItemWide.vue';

export const newsTypes = {
  wide: SpecialProjectItemWide,
  image_background: SpecialProjectItemImageBackground,
  image_big: SpecialProjectItemImageBig,
  expert: SpecialProjectItemExpert,
};

// Внутри статьи wide выглядит как image_big
export const newsTypesArticle = {
  wide: SpecialProjectItemImageBig,
  image_background: SpecialProjectItemImageBackground,
  image_big: SpecialProjectItemImageBig,
  expert: SpecialProjectItemExpert,
};

/* Размеры картинок блоков спецпроекта — из вёрстки. */
export const SPECIAL_ITEM_IMAGE_WIDTH = 320;
export const SPECIAL_ITEM_EXPERT_IMAGE_WIDTH = 80;
